import { getClassificationPromptResult, getPromptResult } from '../utils/ai';

// eslint-disable-next-line import/prefer-default-export
export function getLastLinePreview(text) {
  const lines = text.trim().split('\n');
  const last = lines[lines.length - 1];
  return `[...] ${  last.slice(0, 60)  }${last.length > 60 ? '...' : ''}`;
}

export async function testAgent(dataArr) {
  const output = [];

  for (let i = 0; i < dataArr.length; i += 1) {
    // eslint-disable-next-line no-await-in-loop
    const classification = await getClassificationPromptResult(dataArr[i].input);
    // const scores = await getClassificationPromptResult(dataArr[i].input);
    // eslint-disable-next-line no-await-in-loop
    const feedback = await getPromptResult(dataArr[i].input, classification);

    output.push({
      classification,
      // scores,
      feedback,
      ...dataArr[i]
    });
  }

  return output
}
